const audioCtx = new AudioContext();

const masterGain = audioCtx.createGain();
masterGain.connect(audioCtx.destination);

export function setVolume(value: number) {
    masterGain.gain.value = value;
}

export class Sound {
    private buffer: AudioBuffer | null = null;
    private loopSource: AudioBufferSourceNode | null = null;

    constructor(url: string) {
        fetch(url)
            .then((r) => r.arrayBuffer())
            .then((buf) => audioCtx.decodeAudioData(buf))
            .then((decoded) => { this.buffer = decoded; });
    }

    play() {
        if (!this.buffer) return;
        const source = audioCtx.createBufferSource();
        source.buffer = this.buffer;
        source.connect(masterGain);
        source.start();
    }

    playFor(ms: number) {
        if (!this.buffer) return;
        const fadeTime = 0.05;
        const duration = ms / 1000;
        const now = audioCtx.currentTime;

        const gain = audioCtx.createGain();
        gain.connect(masterGain);
        gain.gain.setValueAtTime(1, now);
        gain.gain.setValueAtTime(1, now + duration - fadeTime);
        gain.gain.linearRampToValueAtTime(0, now + duration);

        const source = audioCtx.createBufferSource();
        source.buffer = this.buffer;
        source.loop = true;
        source.connect(gain);
        source.start(now);
        source.stop(now + duration + fadeTime);
    }

    playLooping() {
        if (!this.buffer || this.loopSource) return;
        const source = audioCtx.createBufferSource();
        source.buffer = this.buffer;
        source.loop = true;
        source.connect(masterGain);
        source.start();
        this.loopSource = source;
    }

    stop() {
        if (this.loopSource) {
            this.loopSource.stop();
            this.loopSource = null;
        }
    }
}

export const buzzerSound = new Sound("buzzer_loop.wav");
